export default {_name:'cart.header',module:'Field',view:'Element/Cart/Header',options:{xs:12,backIcon:'arrow-right',closeIcon:'close'}}